<template>
  <div class="edrone-flex" :class="classes">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "EdroneFlex",
  props: {
    row: Boolean,
    column: Boolean,
    justifyStart: Boolean,
    justifyCenter: Boolean,
    justifyEnd: Boolean,
    spaceBetween: Boolean,
    alignCenter: Boolean,
    alignBaseline: Boolean,
    wrap: Boolean,
  },
  computed: {
    classes() {
      return {
        "edrone-flex--row": this.row,
        "edrone-flex--column": this.column,
        "edrone-flex--justify-start": this.justifyStart,
        "edrone-flex--justify-center": this.justifyCenter,
        "edrone-flex--justify-end": this.justifyEnd,
        "edrone-flex--align-center": this.alignCenter,
        "edrone-flex--align-baseline": this.alignBaseline,
        "edrone-flex--justify-space-between": this.spaceBetween,
        "edrone-flex--wrap": this.wrap,
      };
    },
  },
};
</script>

<style scoped>
.edrone-flex {
  display: flex;
}

.edrone-flex--row {
  flex-direction: row;
}

.edrone-flex--column {
  flex-direction: column;
}

.edrone-flex--justify-start {
  justify-content: flex-start;
}

.edrone-flex--justify-center {
  justify-content: center;
}

.edrone-flex--justify-end {
  justify-content: flex-end;
}

.edrone-flex--justify-space-between {
  justify-content: space-between;
}

.edrone-flex--align-center {
  align-items: center;
}

.edrone-flex--align-baseline {
  align-items: baseline;
}

.edrone-flex--wrap {
  flex-wrap: wrap;
}
</style>
